/* NZS-VP-0929 variety pack box (snippets/nzs-variety-pack.liquid). Vanilla, one IIFE, no Alpine.
   Pick up to cfg.max units from one family (repeats allowed); tiers from cfg.tiers (Liquid, one place).
   PRICE AUTHORITY: the server. An ORDER-class automatic discount ("Variety pack 5% off" / "Variety pack 10% off")
   prices the pack lines; lines keep full price in the cart. This file only MIRRORS that maths for display:
     nTotal = eligible family units already in the cart + picks, pct = tier(nTotal).
     Selected pay = rounded combined-family payable at the new tier minus rounded existing-family payable at its current tier.
   One add: window.nzsATC.add({items:[...merged...]}, {handle, quiet:true}); header-late's fetch hook then opens the
   drawer (nzs:cdr-added-cart). _vpack is tracking only; pricing never reads it (quantity-based, contract 2). */
(function () {
  'use strict';

  /* ---- pure maths (exported for theme/test_vp_math.js) ---- */
  function tierPct(n, tiers) { var p = 0; for (var i = 0; i < tiers.length; i++) { if (n >= tiers[i][0] && tiers[i][1] > p) p = tiers[i][1]; } return p; }
  function nextTier(n, tiers) { var t = null; for (var i = 0; i < tiers.length; i++) { if (tiers[i][0] > n && (!t || tiers[i][0] < t[0])) t = tiers[i]; } return t; }
  function payCents(sum, pct) { return Math.round(sum * (100 - pct) / 100); }
  /* stock cap for one flavour: ip = tracked + deny, so iq is a hard cap (minus what the cart already holds) */
  function stockCap(row, inCartQ, max) { if (!row || !row.a) return 0; if (!row.ip) return max; return Math.max(0, Math.min(max, (parseInt(row.iq, 10) || 0) - (inCartQ || 0))); }
  function roomFor(row, inCartQ, pickedQ, pickedTotal, max) { return Math.max(0, Math.min(max - pickedTotal, stockCap(row, inCartQ, max) - pickedQ)); }
  function fill(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function nudge(nTotal, picked, tiers, max, c) {
    if (nTotal <= 0) return c.n0;
    var cur = tierPct(nTotal, tiers), nx = nextTier(nTotal, tiers);
    if (nx) { var k = nx[0] - nTotal; return (cur > 0 && k > 1) ? fill(c.mid, { pct: cur, k: k, next: nx[1] }) : fill(c.to, { k: k, pct: nx[1] }); }
    return picked >= max ? fill(c.topFull, { pct: cur }) : fill(c.topRoom, { pct: cur, k: max - picked });
  }
  /* Selected quote = the exact change in the eligible family total, including existing-cart tier bumps. */
  function quote(counts, byV, famInCart, tiers, existingSum) {
    var n = 0, sum = 0;
    Object.keys(counts).forEach(function (v) { var q = counts[v] || 0, r = byV[v]; if (!r || q <= 0) return; n += q; sum += q * (r.p || 0); });
    var nTotal = n + (famInCart || 0), pct = tierPct(nTotal, tiers), previousPct = tierPct(famInCart || 0, tiers);
    existingSum = existingSum || 0;
    return { n: n, nTotal: nTotal, pct: pct, sum: sum, pay: payCents(existingSum + sum, pct) - payCents(existingSum, previousPct), bump: famInCart > 0 && n > 0 && pct > tierPct(famInCart, tiers) };
  }
  /* Stock reserves every line; only retail, non-subscription, non-gift lines unlock pack tiers. */
  function cartCounts(c) {
    if (!c || !Array.isArray(c.items)) return null;
    var all = {}, eligible = {}, eligibleSum = {};
    c.items.forEach(function (it) {
      var k = String(it.variant_id != null ? it.variant_id : it.id), qty = parseInt(it.quantity, 10) || 0, props = it.properties || {}, linePrice = it.price != null ? it.price : it.original_price;
      all[k] = (all[k] || 0) + qty;
      if (it.selling_plan_allocation || it.selling_plan || !(Number(linePrice) > 0) || Object.prototype.hasOwnProperty.call(props, '_Free') || Object.prototype.hasOwnProperty.call(props, '_nzs_gift')) return;
      eligible[k] = (eligible[k] || 0) + qty;
      eligibleSum[k] = (eligibleSum[k] || 0) + qty * Number(linePrice);
    });
    return { all: all, eligible: eligible, eligibleSum: eligibleSum };
  }
  function money(cents, fmt) {
    fmt = String(fmt || '${{amount}}').replace(/<[^>]*>/g, '');
    var v = (cents || 0) / 100;
    function d(x, dec, ts, ds) { var s = x.toFixed(dec).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return s[0] + (s[1] ? ds + s[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return d(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(v, 0, '.', ',');
      return d(v, 2, ',', '.');
    });
  }
  /* Shopify 422 stock text: "All N" = N is the stock; "only (add) N" = N more fit (the rail's rule) */
  function stockCount(msg, have) { var m = /\b(all|only)\s+(?:add\s+)?(\d+)\b/i.exec(msg || ''); if (!m) return have; var n = parseInt(m[2], 10); return /^all$/i.test(m[1]) ? n : have + n; }

  var M = { tierPct: tierPct, nextTier: nextTier, payCents: payCents, stockCap: stockCap, roomFor: roomFor, fill: fill, nudge: nudge, quote: quote, cartCounts: cartCounts, money: money, stockCount: stockCount };
  if (typeof module === 'object' && module.exports) { module.exports = M; return; }

  /* ---- DOM ---- */
  var root = document.querySelector('[data-nzs-vp]');
  if (!root || root.__vp) return;
  root.__vp = true;
  var D; try { D = JSON.parse(root.querySelector('[data-vp-data]').textContent); } catch (_) { return; }
  /* NZS-VPACK-1006: Liquid supplies max=10; picks, restore, stock limits and meter share MAX. */
  var C = D.cfg, CP = C.copy, T = C.tiers, MAX = C.max, rows = D.rows || [], byV = {};
  rows.forEach(function (r) { byV[r.v] = r; });
  function $(s, el) { return (el || root).querySelector(s); }
  var slots = [].slice.call(root.querySelectorAll('[data-vp-slot]')), ticks = [].slice.call(root.querySelectorAll('[data-vp-tick]'));
  var elNudge = $('[data-vp-nudge]'), elMsg = $('[data-vp-msg]'), grid = $('[data-vp-grid]'), atc = $('[data-vp-atc]');
  var elL1 = $('[data-vp-l1]'), elPx = $('[data-vp-px]'), elWas = $('[data-vp-was]'), elNow = $('[data-vp-now]'), elClear = $('[data-vp-clear]');
  var bar = document.querySelector('[data-vp-bar]'), barTxt = bar && $('[data-vp-bar-txt]', bar), barBtn = bar && $('[data-vp-bar-btn]', bar), barPx = bar && $('[data-vp-bar-px]', bar);
  var barDots = bar ? [].slice.call(bar.querySelectorAll('.nzs-vp-bar__dots i')) : [];
  var cells = {}; [].slice.call(root.querySelectorAll('[data-vp-cell]')).forEach(function (c) { cells[c.getAttribute('data-vp-cell')] = c; });
  /* NZS-VPACK-BUILD-1006: the quote adapts; the fixed family hero does not change with selections. */
  var section = root.closest('[id^="shopify-section-"]'), priceView = $('[data-vp-price]');
  var priceNow = $('[data-vp-price-now]'), priceWas = $('[data-vp-price-was]'), priceSave = $('[data-vp-price-save]'), priceLabel = $('[data-vp-price-label]');
  var media = section && section.querySelector('[id^="product-media-"]'), heroTemplate = $('[data-vp-hero]');
  if (section) {
    section.classList.add('nzs-vp-section');
    var nativePrice = section.querySelector('.x-block-price .main-product-price');
    if (nativePrice && priceView) {
      if (nativePrice.firstElementChild) nativePrice.firstElementChild.classList.add('nzs-vp-native-price');
      nativePrice.insertBefore(priceView, nativePrice.querySelector('.nzs-brandline-wrap'));
    }
  }
  /* NZS-VPACK-STABLE-1006: one fixed family composite, matching the Specials directory. */
  if (media && heroTemplate) {
    media.classList.add('nzs-vp-media', 'nzs-vp-static-hero');
    media.appendChild(heroTemplate.content.cloneNode(true));
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var order = [];            /* one variant id per picked unit, in pick order (the slot tray) */
  var inCart = {}, eligibleInCart = {}, eligibleCostInCart = {}, cartReady = false, busy = false, flow = 0, lastPct = 0, msgT = null;
  var memKey = 'nzsVpMem:' + C.family + ':' + C.size;

  function counts() { var m = {}; order.forEach(function (v) { m[v] = (m[v] || 0) + 1; }); return m; }
  function famInCart() { var n = 0; rows.forEach(function (r) { n += eligibleInCart[r.v] || 0; }); return n; }
  function famCartSum() { var sum = 0; rows.forEach(function (r) { sum += eligibleCostInCart[r.v] || 0; }); return sum; }
  function nameOf(v) { var r = byV[v]; return r ? r.n : ''; }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); } /* forced reflow, never rAF */
  function memWrite() { try { if (order.length) sessionStorage.setItem(memKey, JSON.stringify(order)); else sessionStorage.removeItem(memKey); } catch (_) {} }
  function memRead() { try { var a = JSON.parse(sessionStorage.getItem(memKey) || '[]'); return Array.isArray(a) ? a : []; } catch (_) { return []; } }
  function cro(ev, q) { try { document.dispatchEvent(new CustomEvent('nzs:cro', { detail: { ev: ev, surface: 'vpack', family: C.family, n: q.n, total: q.nTotal, pct: q.pct } })); } catch (_) {} }

  /* transient line (cap / stock / errors). Idle state = the cart note. Fixed height, text swap only. */
  function idleMsg(q) {
    var fc = famInCart(); if (!fc) return '';
    return fill(q.bump ? CP.cartBump : CP.cart, { n: fc, units: fc === 1 ? C.unit : C.units, pct: q.pct });
  }
  function flash(text, name, ms) {
    elMsg.textContent = name ? name + ': ' + text : text;
    elMsg.classList.add('is-flash');
    clearTimeout(msgT);
    msgT = setTimeout(function () { msgT = null; elMsg.classList.remove('is-flash'); elMsg.textContent = idleMsg(quote(counts(), byV, famInCart(), T, famCartSum())); }, ms || 4000);
  }

  function paint(changed, popIdx) {
    var cnt = counts(), fc = famInCart(), q = quote(cnt, byV, fc, T, famCartSum()), n = order.length;
    Object.keys(cells).forEach(function (v) {
      var c = cells[v], r = byV[v]; if (!r || !r.a) return;
      var qv = cnt[v] || 0, room = roomFor(r, inCart[v] || 0, qv, n, MAX);
      c.classList.toggle('is-sel', qv > 0);
      var sw = c.querySelector('[data-vp-add]'), plus = c.querySelector('[data-vp-q="1"]'), qn = c.querySelector('.nzs-vp__qn');
      if (sw) { sw.setAttribute('aria-pressed', qv > 0 ? 'true' : 'false'); if (room > 0) sw.removeAttribute('aria-disabled'); else sw.setAttribute('aria-disabled', 'true'); }
      if (plus) { if (room > 0) plus.removeAttribute('aria-disabled'); else plus.setAttribute('aria-disabled', 'true'); }
      if (qn && qn.textContent !== String(qv)) { var up = qv > (+qn.textContent || 0); qn.textContent = String(qv); if (String(v) === String(changed) && qv > 0) restart(qn, up ? 'is-up' : 'is-down'); }
    });
    slots.forEach(function (s, i) {
      var v = order[i], img = s.querySelector('img');
      if (v != null) {
        var r = byV[v];
        if (img.getAttribute('src') !== r.img) { if (r.img) img.setAttribute('src', r.img); else img.removeAttribute('src'); }
        img.hidden = !r.img; s.disabled = false; s.classList.add('is-on');
        s.setAttribute('aria-label', fill(CP.slotRemove, { name: r.n }));
        if (i === popIdx) restart(s, 'is-pop');
      } else if (s.classList.contains('is-on')) {
        img.hidden = true; s.disabled = true; s.classList.remove('is-on', 'is-pop');
        s.setAttribute('aria-label', fill(CP.slotEmpty, { i: i + 1 }));
      }
    });
    ticks.forEach(function (t) {
      var min = +t.getAttribute('data-vp-tick'), on = q.nTotal >= min;
      t.classList.toggle('is-on', on);
      if (on && tierPct(min, T) > lastPct) restart(t, 'is-glow');
    });
    lastPct = q.pct;
    var nt = nudge(q.nTotal, n, T, MAX, CP); if (elNudge.textContent !== nt) elNudge.textContent = nt;
    if (!msgT) { var im = idleMsg(q); if (elMsg.textContent !== im) elMsg.textContent = im; }
    var empty = n === 0;
    if (priceView) {
      priceNow.textContent = empty ? (C.min > 0 ? (C.min < C.maxPrice ? 'From ' : '') + money(C.min, C.money) + ' a ' + C.unit : '') : money(q.pay, C.money);
      priceLabel.textContent = empty ? (C.min > 0 ? 'Choose your flavours below' : 'No flavours are available right now.') : (fc > 0 ? 'Added pack total · ' : 'Pack total · ') + n + ' ' + (n === 1 ? C.unit : C.units);
      var saving = !empty && q.pct > 0 && q.sum > q.pay;
      priceWas.hidden = !saving; priceSave.hidden = !saving;
      priceWas.textContent = money(q.sum, C.money);
      priceSave.textContent = saving ? 'Save ' + money(q.sum - q.pay, C.money) + ' · ' + q.pct + '% off' : '';
    }
    atc.classList.toggle('is-empty', empty); atc.setAttribute('aria-disabled', empty ? 'true' : 'false');
    elL1.textContent = empty ? CP.atcEmpty : fill(CP.atcAdd, { n: n, units: n === 1 ? C.unit : C.units });
    elPx.hidden = empty;
    if (!empty) { elNow.textContent = money(q.pay, C.money); elWas.hidden = !(q.pct > 0 && q.sum > q.pay); elWas.textContent = money(q.sum, C.money); }
    elClear.classList.toggle('is-on', !empty);
    if (bar) {
      barDots.forEach(function (d, i) { d.classList.toggle('is-on', i < n); });
      barTxt.textContent = fill(q.pct ? CP.barPct : CP.bar, { n: n, pct: q.pct });
      barPx.textContent = empty ? '' : CP.sep + money(q.pay, C.money);
      barUpdate();
    }
    memWrite();
    return q;
  }

  function addOne(v) {
    var r = byV[v]; if (!r || !r.a) return;
    if (order.length >= MAX) { flash(CP.full); return; }
    var cnt = counts(), have = inCart[v] || 0;
    if (roomFor(r, have, cnt[v] || 0, order.length, MAX) <= 0) { flash(have >= (parseInt(r.iq, 10) || 0) ? CP.stockCart : CP.stock, r.n); return; }
    order.push(r.v);
    cro('vpack_pick', paint(r.v, order.length - 1));
  }
  function removeOne(v) { var i = order.lastIndexOf(+v); if (i > -1) { order.splice(i, 1); paint(+v); } }

  /* clamp picks to caps (after a cart read or a 422 corrects stock) */
  function clampAll() {
    var changed = false, cnt = counts();
    Object.keys(cnt).forEach(function (v) {
      var cap = stockCap(byV[v], inCart[v] || 0, MAX);
      while (cnt[v] > cap) { order.splice(order.lastIndexOf(+v), 1); cnt[v]--; changed = true; }
    });
    return changed;
  }

  function cartMap(c) {
    var mapped = cartCounts(c); if (!mapped) return;
    inCart = mapped.all; eligibleInCart = mapped.eligible; eligibleCostInCart = mapped.eligibleSum; cartReady = true; clampAll(); paint();
  }
  function cartRead() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { cartMap(c); return c; }, function () { return null; });
  }
  ['nzs:cart-added', 'cart:updated', 'nzs:cart-rendered', 'nzs:cdr-added-cart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { cartMap(e.detail && e.detail.cart); });
  });

  /* ---- add ---- */
  function engine() {
    if (window.nzsATC && window.nzsATC.add) return Promise.resolve(window.nzsATC);
    return new Promise(function (res) {
      var t = setTimeout(function () { res(window.nzsATC || null); }, 3000);
      document.addEventListener('nzs:atc-ready', function () { clearTimeout(t); res(window.nzsATC || null); }, { once: true });
    });
  }
  /* last resort when the engine never loads (the button is never dead); header-late's fetch hook still opens the drawer */
  function directAdd(items) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || CP.err); e.status = r.status; throw e; } return j; }); });
  }
  function loadOn(b) { if (window.__nzsLoadOn) window.__nzsLoadOn(b); else { b.classList.add('nzs-loading'); b.setAttribute('aria-busy', 'true'); } }
  function loadOff(b) { if (window.__nzsLoadOff) window.__nzsLoadOff(b); b.classList.remove('nzs-loading'); b.removeAttribute('aria-busy'); }
  function drawerOpen() { var d = document.getElementById('nzsCartDrawer'); return !!(d && d.classList.contains('is-open')); }
  function openDrawer() {
    if (drawerOpen()) return;
    var t = document.getElementById('nzsCartToggle');
    if (t && t.getAttribute('aria-expanded') !== 'true') t.click();
  }
  var STOCK_RE = /your cart|only add|can.t add|sold out|availab|stock/i;

  function submit(btn) {
    if (busy) return;
    if (!order.length) {
      flash(CP.pickFirst);
      var f = grid.querySelector('[data-vp-add]:not([aria-disabled="true"])');
      grid.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      if (f) f.focus({ preventScroll: true });
      return;
    }
    if (clampAll()) { paint(); flash(CP.stock); return; } /* stock changed under us: show the corrected pack before adding */
    var snap = counts(), q = quote(snap, byV, famInCart(), T, famCartSum()), tok = ++flow;
    var items = Object.keys(snap).map(function (v) { return { id: +v, quantity: snap[v], properties: { _vpack: C.family } }; });
    busy = true; root.classList.add('is-busy'); btn.classList.remove('is-added'); loadOn(btn);
    engine().then(function (E) { return E ? E.add({ items: items }, { handle: C.anchor, quiet: true }) : directAdd(items); })
      .then(function (res) {
        if (tok !== flow) return;
        busy = false; root.classList.remove('is-busy'); loadOff(btn);
        btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        /* reset only what this add carried: picks made while it was in flight stay */
        Object.keys(snap).forEach(function (v) { for (var k = 0; k < snap[v]; k++) { var i = order.lastIndexOf(+v); if (i > -1) order.splice(i, 1); } });
        var c = res && (res.cart || (Array.isArray(res.items) && res.token ? res : null));
        if (c) cartMap(c); else paint();
        cro('vpack_add', q);
        setTimeout(openDrawer, 700);
      }, function (err) {
        if (tok !== flow) return;
        busy = false; root.classList.remove('is-busy'); loadOff(btn);
        var msg = (err && err.message) || CP.err;
        if (!(err && err.status === 422 && err.code !== 'LOOKUP_FAILED' && STOCK_RE.test(msg))) { flash(msg, '', 6000); return; }
        /* stock 422 (batches never self-heal): re-read the cart, rewrite the named flavour's cap, clamp, explain */
        var lm = msg.toLowerCase(), vs = Object.keys(snap), hit = vs.length === 1 ? vs[0] : vs.filter(function (v) { var r = byV[v]; return r && lm.indexOf(String(r.t).toLowerCase()) > -1; })[0];
        cartRead().then(function () {
          if (hit) { var r = byV[hit]; r.ip = 1; r.iq = stockCount(msg, inCart[hit] || 0); }
          clampAll(); paint(); flash(msg, '', 6000);
        });
      });
  }

  /* ---- events ---- */
  root.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-vp-q]'))) { var v = +b.getAttribute('data-vp-v'); if (b.getAttribute('data-vp-q') === '1') addOne(v); else removeOne(v); return; }
    if ((b = e.target.closest('[data-vp-add]'))) { addOne(+b.getAttribute('data-vp-add')); return; }
    if ((b = e.target.closest('[data-vp-slot]'))) {
      var i = +b.getAttribute('data-vp-slot'); if (order[i] == null) return;
      var sv = order[i]; order.splice(i, 1); paint(sv);
      if (b.disabled) { var nx = slots.filter(function (s) { return !s.disabled; }).pop(); (nx || grid.querySelector('[data-vp-add]')).focus({ preventScroll: true }); }
      return;
    }
    if (e.target.closest('[data-vp-clear]')) { order = []; paint(); return; }
    if (e.target.closest('[data-vp-atc]')) submit(atc);
  });

  /* ---- sticky pack bar (<=768px): shows when the box ATC is above the viewport, or below it while picks exist ---- */
  var barOn = false, mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : { matches: false };
  var footer = document.querySelector('.nzs-footer') || document.querySelector('footer');
  function barUpdate() {
    if (!bar) return;
    var show = false;
    if (mq.matches && !drawerOpen()) {
      var r = atc.getBoundingClientRect(), ih = window.innerHeight;
      show = r.bottom <= 0 || (r.top >= ih && order.length > 0);
      if (show && footer) { var fr = footer.getBoundingClientRect(); if (fr.top < ih - 90) show = false; }
    }
    if (show === barOn) return;
    barOn = show;
    if (!show && bar.contains(document.activeElement)) atc.focus({ preventScroll: true });
    bar.classList.toggle('is-on', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) { bar.removeAttribute('inert'); document.body.classList.add('nzs-vp-pad'); } else bar.setAttribute('inert', ''); /* reserve padding stays once shown (no jump at the page end) */
  }
  if (bar) {
    if (bar.parentNode !== document.body) document.body.appendChild(bar); /* fixed inside a transformed ancestor never renders; moved once */
    barBtn.addEventListener('click', function () {
      if (order.length) { submit(barBtn); return; }
      atc.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', barUpdate, { passive: true });
    window.addEventListener('resize', barUpdate, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', barUpdate); else if (mq.addListener) mq.addListener(barUpdate);
    if ('IntersectionObserver' in window) new IntersectionObserver(barUpdate).observe(atc);
    var dr = document.getElementById('nzsCartDrawer');
    if (dr && window.MutationObserver) new MutationObserver(barUpdate).observe(dr, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- boot ---- */
  memRead().forEach(function (v) { var r = byV[v]; if (r && r.a && order.length < MAX && roomFor(r, 0, counts()[v] || 0, order.length, MAX) > 0) order.push(r.v); });
  var q0 = paint();
  var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
  ric(function () { if (!cartReady) cartRead(); }, { timeout: 2500 });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); cro('vpack_impression', quote(counts(), byV, famInCart(), T, famCartSum())); } }, { threshold: 0.5 });
    io.observe(root);
  } else cro('vpack_impression', q0);
})();
